export enum AuthQueryKeys {
  GET_MY_REFERRAL = 'GET_MY_REFERRAL',
  GET_ADMIN_PERMISSIONS = 'GET_ADMIN_PERMISSIONS',
}
